<div *ngIf="($vm | async) as vm">
  <div *ngIf="(authState$ | async) as authState">

    <header *ngIf="shellService.showChrome" class="h-100" id="pageheader">

      <!-- Sidebar navigation -->
      <mdb-side-nav #sidenav [fixed]="false" >

        <mdb-navbar-brand class="pb-3">
          <li>
            <div class="logo-wrapper waves-light text-center">
              <a class="logo navbar-brand" (click)="sidenav.hide()">
                <button type="button" class="close" aria-label="Close" (click)="sidenav.hide()"
                  style="padding-right: 10px; padding-top: 5px; color: rgb(255, 255, 255, .56)">
                  <span aria-hidden="true">&times;</span>
                </button>
                <strong>{{shell.displayTitle}}</strong>
              </a>
            </div>
          </li>
          <!--/. Logo -->
        </mdb-navbar-brand>

        <links>
          <!--Search Form-->
          <li>
            <form class="search-form" role="search">
              <div class="form-group md-form mt-0 pt-1 waves-light" mdbWavesEffect>
                <input type="text" class="form-control" placeholder="search" #search
                  (keyup.enter)="sidenav.hide(); shell.searchTermEntered(search.value);">
              </div>
            </form>
          </li>
          <!--/.Search Form-->
          <li>
            <div style="text-align: center; font-size: 10px">
              <div>{{lastUpdatedValue}}</div>
            </div>
          </li>
          <!-- Side navigation links -->
          <li>
            <ul class="collapsible collapsible-accordion">
              <!-- <li>
                <a href="/" target="_self" (click)="sidenav.hide()"><i name="prev-version" class="mr-1 fa fa-arrow-left"></i><span>
                    ECLSWeb 1.0</span></a>
              </li> -->

              <mdb-squeezebox [multiple]="false" aria-multiselectable="false">

                <mdb-item class="no-collase" *ngIf="vm.mainSections.length > 0">
                  <mdb-item-head mdbWavesEffect routerLink="/" (click)="sidenav.hide()">
                    <mdb-icon fas icon="home"></mdb-icon> Home
                  </mdb-item-head>
                  <mdb-item-body></mdb-item-body>
                </mdb-item>
                <mdb-item *ngFor="let nl of vm.mainSections">
                  <div *ngIf='((demoEnv && nl.canViewInDemoEnv) || !demoEnv)'>
                    <mdb-item-head mdbWavesEffect>{{nl.name}}</mdb-item-head>
                    <mdb-item-body>
                      <ul *ngIf="nl.pages">
                        <li *ngFor="let np of nl.pages">
                          <div *ngIf='(demoEnv && np.canViewInDemoEnv) || !demoEnv'>
                            <a *ngIf="np.routerLink" (click)="sidenav.hide()" routerLink="{{np.routerLink}}"
                              class="waves-effect" mdbWavesEffect>{{np.name}}</a>
                            <a *ngIf="np.href" target="_self" (click)="sidenav.hide()" href="{{np.href}}"
                              class="waves-effect" mdbWavesEffect>{{np.name}}</a>
                          </div>
                        </li>
                      </ul>
                    </mdb-item-body>
                  </div>
                </mdb-item>

                <mdb-item class="no-collase" *ngIf="vm.contactCenterSections.length > 0">
                  <mdb-item-head mdbWavesEffect>
                    <mdb-icon fas icon="phone-volume"></mdb-icon>Contact Center
                  </mdb-item-head>
                  <mdb-item-body></mdb-item-body>
                </mdb-item>

                <mdb-item *ngFor="let nl of vm.contactCenterSections">
                  <div *ngIf='(demoEnv && nl.canViewInDemoEnv) || !demoEnv'>
                    <mdb-item-head mdbWavesEffect>{{nl.name}}</mdb-item-head>
                    <mdb-item-body>
                      <ul *ngIf="nl.pages">
                        <li *ngFor="let np of nl.pages">
                          <div *ngIf='(demoEnv && np.canViewInDemoEnv) || !demoEnv'>
                            <a *ngIf="np.routerLink" (click)="sidenav.hide()" routerLink="{{np.routerLink}}"
                              class="waves-effect" mdbWavesEffect>{{np.name}}</a>
                            <a *ngIf="np.href" target="_self" (click)="sidenav.hide()" href="{{np.href}}"
                              class="waves-effect" mdbWavesEffect>{{np.name}}</a>
                          </div>
                        </li>
                      </ul>
                    </mdb-item-body>
                  </div>
                </mdb-item>
              </mdb-squeezebox>

            </ul>
          </li>
          <!--/. Side navigation links -->
        </links>
        <div class="sidenav-bg mask-strong"></div>
      </mdb-side-nav>
      <!--/. Sidebar navigation -->

      <mdb-navbar *ngIf="authState.isLoggedIn"
        SideClass="navbar fixed-top navbar-expand-lg navbar-dark blue-gradient scrolling-navbar intro-fixed-nav navbar-toggleable-md double-nav"
        [containerInside]="false">
        <navlinks class="navbar-container">
          <!-- SideNav slide-out button -->
          <div class="float-left white-text">
            <a (click)="sidenav.show()" class="button-collapse hidden-nav-button-collapse">
              <i class="fa fa-bars"></i>
            </a>
          </div>
          <!--/. SideNav slide-out button -->
        </navlinks>

        <mdb-navbar-brand>
          <!-- Breadcrumb-->
          <div class="breadcrumbs breadcrumbs-hidden-nav breadcrumb-dn mr-auto">
            <a class="logo navbar-brand" routerLink="/"><strong>{{shell.displayTitle}}</strong></a>

          </div>
          <!--/. Breadcrumb-->

        </mdb-navbar-brand>

        <navlinks (click)="sidenav.hide()">
          <ul class="nav navbar-nav ml-auto nav-flex-icons ie-double-nav ie-hidden-double-nav"
            *ngIf="!authState.isLoggedIn">
            <li class="nav-item">
              <a class="nav-link waves-effect waves-light" routerLink="/login">Login</a>
            </li>
          </ul>

          <ul class="nav navbar-nav ml-auto nav-flex-icons ie-double-nav ie-hidden-double-nav"
            *ngIf="authState.isLoggedIn">
            <!-- <li class="nav-item">
              <a class="nav-link waves-effect waves-light" routerLink="/feedback"><i class="fa fa-envelope"></i></a>
            </li>
            <li class="nav-item">
              <a class="nav-link waves-effect waves-light" routerLink="/notifications">1<i class="fa fa-bell"></i></a>
            </li> -->
            <li class="nav-item avatar dropdown" mdbDropdown>
              <!--Trigger-->
              <a mdbDropdownToggle color="indigo" class="dropdown-toggle waves-light" mdbWavesEffect>
                <!-- <img src="https://mdbootstrap.com/img/Photos/Avatars/avatar-2.jpg" class="img-fluid rounded-circle z-depth-0"> -->
                <img src="{{authState.user.profileImageLink}}" class="img-fluid rounded-circle z-depth-0">

                <span class="pl-2 mdb-color white-text">{{authState.user.userName}}</span>
              </a>


              <!--Menu-->
              <!-- todo... need to remove alignment class when collapsed -->
              <div class="dropdown-menu dropdown-primary dropdown-menu-right">
                <!-- <a class="dropdown-item" routerLink="/profiles/me">My Profile</a>
                <a class="dropdown-item" routerLink="/settings">Settings</a>
                <div class="divider dropdown-divider"></div>-->
                <a class="dropdown-item" (click)="logout()">Logout</a>
              </div>
            </li>
          </ul>
        </navlinks>
      </mdb-navbar>

      <!-- Main -->
      <div style="height: 60px;">
      </div>
    </header>

    <!-- fixed nav buttons -->
    <div *ngIf="shellService.showChrome && authState.isLoggedIn">
      <div class="fixed-action-btn" style="bottom: 10px; right: -5px;">
        <a mdbBtn floating="true" size="sm" gradient="blue" mdbWavesEffectj (click)="shell.goBack()">
          <i class="fa fa-arrow-left"></i>
        </a>
      </div>
      <!--
      <div class="fixed-action-btn" style="bottom: 10px; right: 10px;">
        <a mdbBtn floating="true" size="sm" gradient="blue" mdbWavesEffect (click)="shell.goHome()">
          <i class="fa fa-home"></i>
        </a>
      </div> -->
    </div>

    <main *ngIf="shellService.showChrome" class="py-2 px-md-5 my-0 mx-0">
      <div>
        <router-outlet></router-outlet>
      </div>
    </main>

    <main *ngIf="!shellService.showChrome">
      <div>
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>
